import { useEffect, useState } from "react";
import { apiGet, apiPost, apiDelete } from "../api/api"; // ajusta se tiverem outros nomes

export default function LocalizacaoGestao() {
  const [distrito, setDistrito] = useState("");
  const [concelho, setConcelho] = useState("");
  const [freguesia, setFreguesia] = useState("");

  const [localizacoes, setLocalizacoes] = useState([]);

  async function carregarLocalizacoes() {
    try {
      const data = await apiGet("/localizacoes/");
      setLocalizacoes(data);
    } catch (e) {
      console.error("Erro ao carregar localizações", e);
    }
  }

  useEffect(() => {
    carregarLocalizacoes();
  }, []);

  async function criarLocalizacao(e) {
    e.preventDefault();
    try {
      await apiPost("/localizacoes/", { distrito, concelho, freguesia });
      setDistrito("");
      setConcelho("");
      setFreguesia("");
      await carregarLocalizacoes();
    } catch (e) {
      alert("Erro ao criar localização");
      console.error(e);
    }
  }

  async function apagarLocalizacao(id) {
    if (!window.confirm("Tem a certeza que quer apagar esta localização?")) return;
    try {
      await apiDelete(`/localizacoes/${id}`);
      await carregarLocalizacoes();
    } catch (e) {
      alert("Erro ao apagar localização");
      console.error(e);
    }
  }

  return (
    <div style={{ padding: 20 }}>
      <h1>Gestão de Localizações</h1>

      <form onSubmit={criarLocalizacao} style={{ marginBottom: 20 }}>
        <input
          placeholder="Distrito"
          value={distrito}
          onChange={(e) => setDistrito(e.target.value)}
        />
        <input
          placeholder="Concelho"
          value={concelho}
          onChange={(e) => setConcelho(e.target.value)}
        />
        <input
          placeholder="Freguesia"
          value={freguesia}
          onChange={(e) => setFreguesia(e.target.value)}
        />
        <button type="submit">Adicionar</button>
      </form>

      <table border="1" cellPadding="5">
        <thead>
          <tr>
            <th>ID</th>
            <th>Distrito</th>
            <th>Concelho</th>
            <th>Freguesia</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          {localizacoes.map((loc) => (
            <tr key={loc.id}>
              <td>{loc.id}</td>
              <td>{loc.distrito}</td>
              <td>{loc.concelho}</td>
              <td>{loc.freguesia}</td>
              <td>
                <button onClick={() => apagarLocalizacao(loc.id)}>Apagar</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
